// extracted by mini-css-extract-plugin
export default {"svgWrapped":"SvgWithTooltip_svgWrapped__UVNgD","svgTooltip":"SvgWithTooltip_svgTooltip__O7Phf"};